import { useTranslation } from 'react-i18next';

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogTitle,
} from '@codes/ui-kit/components/ui/alert-dialog';

interface PaymentConfirmDialogProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
}

export const PaymentConfirmDialog = ({ isOpen, onOpenChange, onConfirm }: PaymentConfirmDialogProps) => {
    const { t } = useTranslation();

    const handleConfirm = () => {
        onOpenChange(false);
        onConfirm();
    };

    return (
        <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogTitle>{t('serviceRequest.registerPaymentMethod')}</AlertDialogTitle>
                <AlertDialogDescription>{t('serviceRequest.registerCardToProceed')}</AlertDialogDescription>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={() => onOpenChange(false)}>
                        {t('serviceRequest.close')}
                    </AlertDialogCancel>
                    <AlertDialogAction onClick={handleConfirm}>{t('serviceRequest.registerCard')}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
